import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/findSimilar';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { kind = 'signal', key, eventId, k = 10 } = action?.payload || {};
  const params = new URLSearchParams({ kind, k: String(k) });
  if (kind === 'event') {
    params.set('event_id', eventId || '');
  } else {
    params.set('key', key || '');
  }
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/goals/similar?${params.toString()}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
  } catch (error) {
    // 503 = the similarity index is down. That's a designed degradation,
    // not a platform error — surface it inline, no global error toast.
    if (error?.response?.status === 503) {
      yield put(fetchSuccess({
        unavailable: true,
        message: error?.response?.data?.data?.message
          || 'The similarity index is not reachable right now.',
        results: [],
      }));
      return;
    }
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
